export const ACCOUNT_INFO = "ACCOUNT_INFO";
export const IS_HARD_MONEY_LOAN = "IS_HARD_MONEY_LOAN";
export const UPDATE_LEAD_SOURCE = "UPDATE_LEAD_SOURCE";
